import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/finishChildcare/index'
import {Request} from 'pages/withAuth/adminPage/procedures/finishChildcare/request'
import {FinishChildcareFlow} from 'pages/withAuth/adminPage/procedures/finishChildcare/flow'
import {Confirm} from 'pages/withAuth/adminPage/procedures/finishChildcare/confirm'

export const FinishChildcareRoutes: RouteParams[] = [
  {
    key: 'finish_childcare',
    path: WITH_AUTH_ADMIN_PATHS.FINISH_CHILDCARE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'finish_childcare/request',
    path: WITH_AUTH_ADMIN_PATHS.FINISH_CHILDCARE.REQUEST,
    component: Request,
    exact: true,
  },
  {
    key: 'finish_childcare/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.FINISH_CHILDCARE.FLOW,
    component: FinishChildcareFlow,
    exact: true,
  },
  {
    key: 'finish_childcare/confirm/:id',
    path: WITH_AUTH_ADMIN_PATHS.FINISH_CHILDCARE.CONFIRM,
    component: Confirm,
    exact: true,
  },
]
